import { Box, styled } from "@mui/material";

export const SearchBarWrapper = styled(Box)(() => ({
    marginTop: "15px",
    marginBottom: "25px",
    marginLeft: "25px",
    marginRight: "25px",
    gap: "1rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
}));
